import { Genders } from "../../types";

export const messages = {
  app: {
    appName: "Pastime",
    arr: "© 2022 Pastime. All right reserved.",
  },
  videoCall: {
    title: "Pastime",
    UserName: (name: number | string) => `name: ${name}`,
    UserId: (uid: number | string) => `User ID: ${uid}`,
    userName: "User name",
    starButton: {
      removeFriend: "Remove Friend",
      addFriend: "Add Friend",
      addTheUser: (userName = "user") => `Star ${userName} to meet again on Pastime`,
    },
    leaveRoomDialog: {
      title: "Are you sure?",
      text: "Once you leave, you may not be able to go back to this room. ",
    },
    fifthDialog: {
      title: "Warning",
      text: "The room you're attempting to enter is currently full. Please retry later.",
    },
    localUser: "You",
    youStarred: "You starred",
    yourReportSent: "Your report has been sent",
    friendRemoved: "Friend removed",
    friendIsUnblocked: "Friend is unblocked",
    controlPanel: {
      onVideo: "On video",
      offVideo: "Off video",
      mute: "Mute",
      unmute: "Unmute",
      switchChannel: "Switch",
      settings: "Settings",
      leave: "Leave",
    },
    addFriendText: (gender = Genders.MALE) =>
      `Now ${heShe(gender)} is on your starred friends list. You can invite ${himHer(gender)} to any room and ${heShe(
        gender
      )} will be notified.`,
    maybeYouWillNotJoinTheSameChannel: "Are you sure? Once you switch, you can't go back to this room.",
    inviteFriends: "Invite Friends",
    dialog: {
      block: "Block",
      report: "Report",
      middleText: (fullname = "user") =>
        `Block or Report ${fullname} for inappropriate behavior so you won't meet again. We won't tell ${fullname}.`,
    },
  },
  findAvailableChannel: {
    button: "Back to Rooms",
    title: "Take a breather",
    subTitle: "Click the button when you're ready to rejoin.",
    description: "We'll try to land you back where you came from. If we can't - you'll join a new room. ",
  },
  friendList: {
    title: "Friend List",
    UserName: (name: number | string) => `Name: ${name}`,
    friend: {
      alreadyInChannel: "Already In a Room",
      invite: "Invite",
      join: "Join",
      sent: "Sent",
    },
    close: "Close",
    youBlockedFriend: (fullname = "friend") => `You blocked ${fullname}!`,
    youWillNoLongerSee: (gender = Genders.MALE) =>
      `And you will no longer see ${himHer(gender)} in the future rooms you visit.`,
  },
  onboarding: {
    nextButton: "Next",
    home: {
      description: "A quick walk-through to get you settled ",
      button: "Let's start",
    },
    settings: {
      description: "Lastly, set up your video cam and microphone ",
      button: "Join a conversation ",
    },
    stepsDescription: [
      "You meet people in small group of called rooms",
      "You can move between rooms, and meet new people",
      "If you enjoy talking to someone you can star him to meet again",
      "Block or report someone, if you don't want to meet him again",
    ],
    new: {
      welcome: {
        title: "Ready to meet interesting people and make new friends on ||Pastime video|| chat?",
        button: "I am ready",
      },
      permissions: {
        title: "||Enable|| your ||camera and microphone|| to start Pastime and ||meet new friends||.",
        button: "Enable Permissions",
        buttonContinue: "Continue",
        youLookGreat: "You look great!",
      },
    },
  },
  settings: {
    title: "Settings",
    close: "Close",
    camera: {
      title: "Camera",
      select: "Select Camera",
    },
    microphone: {
      title: "Microphone",
      select: "Select Microphone",
      pleaseUnmute: "Please unmute your microphone",
    },
    speakers: {
      title: "Speakers",
      select: "Select Speakers",
    },
  },
  account: {
    title: "Profile",
    firstName: "First Name",
    lastName: "Last Name",
    state: "State",
    gender: "Gender",
    birthDay: "B-day",
    phone: "Phone",
    email: "Email",
    onlyVisible: "Only visible for you",
    education: "Degree",
    bio: "Bio",
    about: "About",
    anyUser: "(Any user can see this info)",
    saveChanges: "Save changes",
    deactivateAccount: "Deactivate my account",
    uploadPhoto: {
      youCanUpload: "You can upload a JPG, GIF or PNG file",
      maximum: "Maximum file size is 10 MB",
    },
    banner: {
      title: "Upgrade account",
      description: "To get unlimited features, please upgrade your account",
      button: "Upgrade",
    },
    unsaved: {
      title: "Unsaved changes",
      description: "You have unsaved changes. Are you sure want to leave without saving?",
      button: "Discard changes",
    },
    deactivate: {
      title: "Deactivate account",
      description:
        "Are you sure you want to deactivate your account and delete permanently all information about yourself?",
    },
    isInvalidAge: "Sorry. You must be at least 60 to join.",
  },
  home: {
    register: {
      button: "Sign Up",
    },
    login: {
      button: "Sign In",
    },
    general: { title: "Welcome to" },
  },
  getChannel: {
    loader: {
      lookingForAvailableChannel: "Searching for an available room",
      notFound: "No available room found",
      tryAgain: "Try again",
      connectionToChannel: "Connecting to room",
      youCantConnect: "We are are unable to connect you to this room",
      findAvailable: "Find an available room",
    },
    addInformationModal: {
      title: "Looks like this is your first time",
      fullName: {
        title: "Enter Your Full Name",
        placeholder: "Full Name",
      },
      gender: {
        title: "Select Your Gender",
        placeholder: "Select Gender",
      },
      submit: "Submit",
    },
    sorry: "We are sorry,",
    notFound: "we couldn't find",
    an: "an",
    available: "available",
    roomE: " room 😔",
    room: " room",
    weTryAgain: "Don't worry, we will try again and find you one this time.",
    searchAgain: "Search again",
    waitWhile: "Please wait while",
    weTryTo: "we try to",
    in: "in",
    place: "place",
    roomYouWere: "the room you were",
    invited: "invited",
    to: "to",
    wait: "Please wait",
    whileWe: "while we",
    find: "find",
    forYou: "for you",
    alreadyConnected: "This user is already connected!",
    firstSearch: {
      holdOnAsWeMatchYouWithThe: "Hold on as we match you with the",
      mostCompatibleFriends: "most compatible friends",
      gettingThings: "Getting things",
      perfect: "perfect",
      theFirstTimeCanTakeA: "the first time can take a",
      fewMinutes: "few minutes",
      andWePromiseIt: ", and we promise it's worth it.",
    },
  },
  notFoundChannel: {
    title: "Sorry. Presently, there are no available rooms on Pastime",
    subtitle: "We can alert you when a room becomes available",
    description: "We will send you an SMS message with a link to join in a short while.",
    variants: {
      notify: "Notify me when I can join a room",
      keepWaiting: "I prefer to keep waiting",
    },
    buttons: {
      notify: "Notify me",
      keepWaiting: "Keep waiting",
    },
    dialog: {
      title: "Pastime",
      description: "We will notify you when a room is available, you can close Pastime for now.",
      button: "OK",
    },
  },
  notAvailableTime: {
    title: (from = "1:00 PM", to = "2:00 AM") => `${from} and ${to} local time`,
    title2: "You can enter Pastime daily between",
    description: "Reserve your spot for today and get an SMS notification when Pastime opens.",
    button: "Reserve a Spot",
    dialog: {
      title: "",
      description: "We will notify you when your time arrives.",
      button: "OK",
    },
  },
  authentication: {
    OTP: {
      title: "Enter your code ",
      description: "Check your messages for your personal code. We sent it to to",
      didNotReceiveCode: "Did Not Receive Code?",
      submit: "Submit",
      codeSent: "Code Sent!",
      codeNotSent: "Error with sending code",
      codeIsNotValid: "Code Is Not Valid!",
      label: "Verification Code",
      sendAgain: "Resend code",
      changePhone: "Use another phone number",
    },
    phoneNumber: {
      invalidNumber: "Invalid Number",
      title: { login: "Login to your account", register: "Account setup" },
      enterPhoneNumber: {
        login: "Enter your phone number to access Pastime",
        register: "Enter your phone number and get a code to help secure your account",
      },
      submit: "Continue",
      dialCode: "Dial Code",
      question: { login: "Don't have an account?", register: "Already have an account?" },
      switchText: { login: "Sign up for free ", register: "Login to your account" },
      subtitle: {
        login: "",
        register:
          "By registering you agree to receive SMS notification messages and marketing updates from Pastime on activities",
      },
      label: "Phone number",
      placeholder: "Type your phone",
      weWillNever:
        "We will never share your information, and it will be maintained in the strictest confidentiality. Your phone number serves as your unique login.",
    },
    linkSent: {
      title: "Verification link sent",
      description: "We just sent the verification link via SMS to",
      clickLink: "Click on the link to log in to your account",
      notReceived: "Didn’t receive the message?",
      sendAgain: "Send it again",
      sentAgain: "The invitation link sent again",
    },
  },

  accountSetup: {
    basic: {
      title: "Your details ",
      description: "You name will be displayed. Your birthdate will not.",
      firstName: { label: "First Name", placeholder: "Enter your first name" },
      lastName: { label: "Last Name", placeholder: "Enter your last name" },
      birthday: { label: "Date of birth", placeholder: "MM/DD/YYYY" },
      submit: "Next",
    },
    gender: {
      title: "Your gender",
      description: "How do you identify?",
      submit: "Next",
    },
    state: {
      title: "Place of residence",
      description: "Which state or country is your home?",
      state: { label: "State name", placeholder: "Choose state" },
      submit: "Next",
    },
    education: {
      title: "Education level ",
      description: "What's your academic background?",
      submit: "Next",
    },
    email: {
      title: "What's your email address?",
      description: "Please provide your most current email address",
      description2: "We'll send you an email to confirm this address is valid",
      email: { label: "Your best email", placeholder: "myname@email.com" },
      submit: "Continue",
    },
    avatar: {
      title: "Add your profile picture",
      description: "Help other members remember you better by your picture",
      submit: "Continue",
    },
    bio: {
      title: "Share a little about yourself",
      description: "A short intro will help other Pastime members know you better",
      subtitle:
        "(A minimum of 30 words is required; you can see the number of words you wrote on the counter below the text box)",
      bio: {
        label: "",
        placeholder:
          "Tell fellow members who you are and what you love to do - in 30 words or more.\n\nThis will be visible to Pastime members.",
      },
      submit: "Continue",
    },
    interests: {
      title: "What do you like to talk about?",
      description: "We'll do our best to match you with people with similar interests",
      submit: "Continue",
    },
  },
  internetConnection: {
    lostConnection: "Internet connection lost",
    connectionRestored: "Internet connection restored",
    waitingConnection: "Waiting internet connection...",
  },
  deviceConnection: {
    noDeviceConnected: "Device not connected",
  },
  header: {
    menu: {
      viewProfile: "View Profile",
      following: "Starred",
      notificationsSettings: "Notifications settings",
      helpFeedback: "Help & Feedback",
      logOut: "Log out",
    },
  },
  inviteFriends: {
    close: "Close",
    starred: "Starred",
    community: "Community",
    title: "Invite friends",
    shareLink: "Share link",
    inviteYourFriends: "Invite anyone to Pastime",
    linkWasCopied: "The invitation link was copied to clipboard",
    description: "Share this private link with your friends ",
    share: {
      title: "Pastime invitation link",
      text: (fullname = "User") =>
        `${fullname} is inviting you to meet on Pastime. \nPastime is the online space for active agers who love to meet people and make new friends`,
    },
  },
  notifications: {
    title: "Notifications",
    latest: "Latest",
    zeroState: {
      title: "There are no notifications yet 😔",
      description: "When you get notifications, they’ll show up here 🔔",
      button: "Refresh",
    },
    dialog: {
      title: "Warning",
      description: "Lost socket (sse) connection!",
    },
  },
  following: {
    title: "Following",
    starred: "Starred",
    blocked: "Blocked",
    close: "Close",
    search: "Search...",
    follower: {
      block: "Block",
      unfollow: "Unfollow",
      report: "Report",
      unblock: "Unblock",
      unblocking: "Unblocking...",
      unblockUser: "Unblock user",
      areYouSure: (fullname = "user") => `Are you sure you want to unblock ${fullname}?`,
    },
    zeroData: {
      starred: {
        title: "It looks like you don’t have any Pastime friends yet 😔",
        description:
          "Star ⭐️ people you want to meet on pastime again, and you will see them here. They won’t know you stared them.",
      },
      blocked: {
        title: "It looks like you don’t have any blocked users yet 😊",
        description:
          "Block 🚫 someone, if you don’t want to meet him again, and you will see them here. They won’t know you stared them.",
      },
      hmm: "Hmmm...",
      noResults: "We couldn't find any matches for ",
      sadEmoji: "😔",
      tipsTitle: "Search tips:",
      tryAnotherTip: "Try another search",
      checkSpellingTip: "Check your spelling",
    },
  },
  notificationSettings: {
    description:
      "Notifications are important because they let you know when people you meet enjoyed talking to are available to talk",
    title: "Notification settings",
    switchers: {
      notifyStarredOnline: "Notify me when people I met and starred are online",
      inviteMeToRoom: "Invited me to a room",
      emailMeFriendJoindPatime: "Email me when people I know joined Pastime",
      notifyKnownOnline: "Notify me when people I know joined Pastime",
      updateds: "There are important updates",
      autoStarUsers: "Auto star users",
    },
  },
  loader: {
    text: "Loading",
  },
  rotateDevice: {
    header: "Attention",
    text: "Please, rotate your device to portrait mode",
  },
  getChannelBanner: {
    estimated: "Estimated connection time",
    seconds: "seconds",
    minutes: "minutes",
    title: (isJoining = false) => `Room ${isJoining ? "join" : "search"} in progress`,
  },
  receivedInvitation: {
    invite: "Invite Sent",
    sendInvite: "Send Invite",
    accepted: "Accepted",
    declined: "Declined",
    joinRoom: "Join Room",
    decline: "Decline",
  },
  developerMode: {
    developerAuth: "Developer Auth",
    submit: "Submit",
  },

  aloneDialog: {
    title: "Message",
    one: "It looks like it's a little empty here :)",
    two: "Please wait a few seconds while we try to add more people to the room.",
    three: "If no one joins soon, we will move you to a new room!",
    switchChannel: "Switch in",
  },
  detectDialog: {
    title: "Are you still here?",
    body: "We think you are not here anymore",
    stay: "I'm, right here",
    leave: "Leave call",
  },
  allowPermissions: {
    title: "Please enable your camera and microphone in your browser when promoded on the screen",
    disclaimer: "Without them, you will not be able to join Pastime rooms.",
    button: "I understand",
  },
  blockedPermissions: {
    oops: "Ooops...",
    disabledDevices: "It looks like your camera and sound are not enabled 😔",
    all: "All Pastime conversations take place over ||live video.",
    please: "Please ||enable your video|| and microphone ||to continue using Pastime.",
    learn: "Play the video below to learn how to enable your camera and microphone in a few steps 👇",
    after: "After you have enabled your video and microphone join Pastime again",
    button: "Let's start",
  },
  permissionsInstruction: {
    howTo: "How to give access to your camera and microphone in your browser?",
    description: "To enable your camera and microphone to run Pastime on your phone, please use the following steps",
    title: "Google Chrome",
    after: "Once you have enabled your Camera and Microphone, you can continue to Pastime join our fun rooms.",
    button: "Let's start",
  },
  letsStartToTalkDialog: {
    title: "Let's start to talk",
    hi: (fullname = "User") => `Hi ${fullname}!`,
    welcome: "Welcome to Pastime 😄!",
    introduce: "Please introduce yourself to everyone in the room.",
    whereAreYouFromAndWhatYouLove: "Tell them where you are from and what you love to do in your Pastime.",
    weAreAllFriendsHere: "We are all friends here :)",
    buttonText: "Let's start",
  },
  sayHelloDialog: {
    title: (name: string, from?: string) => `Welcome ${name}${from ? ` from ${from}` : ""}!`,
    description: (name: string) => `Everyone, please say hello to ${name} 🫶`,
  },
  betaFlow: {
    welcome: {
      youAreOnOur: "You are on our",
      waitingList: "waiting list!",
      weAreExperiencing:
        "We’re experiencing a massive demand and a temporarily limited room capacity.  We’ll update you as soon as you can join Pastime",

      thereAre: "There are",
      peopleAheadOfYou: "people ahead of you",
      to: "To",
      skip: "skip",
      theLine: "the line,\nanswer a",
      few: "few ",
      questions: "questions.",
      bumpMeUpTheQueue: "Bump me up the queue",
    },
    finish: {
      wootWoot: "Woot woot! You’ve moved ahead  in the queue!",

      youAreNow: "You are now",
      onTheList: "on the list!",
      descriptionBold: "Invite your friends to Pastime to jump further ahead. ",
      description: "The more friends you invite, the earlier your access.",
      inviteFriends: "Invite friends to Pastime",
      inviteWillBeSent: (amount: number) => `Invite will be sent to ${amount} friends:`,
      messagePreview:
        "I just signed up for Pastime, a video platform where active agers can meet, talk, and make friends. You can sign up as well with my invite.",
      selectContacts: "Select contacts to whom an invite to Pastime will be sent",
      selectButtonText: "Select from address book",
      shareThisLink: "Share this private link with your friends",
      shareButtonText: "Share",
    },
    success: {
      thankYou: "Thank you for sharing Pastime\nwith your friends!",
      youAreNow: "You are now",
      onTheList: "on the list!",
      followUs: "Follow us on Facebook for fun\ncontent that will make you\nsmile",
      findUs: "Find us on",
    },
  },
  kickOutDialog: {
    title: "Kicking out",
    description: (fullname = "user") => `Are you sure you want to kick out ${fullname}?`,
  },
  acceptPermissionsDialog: {
    1: {
      title: "Pastime",
      description:
        "Kindly approve your Camera and Microphone permissions when prompted. This ensures that you can view and speak with everyone on Pastime.",
      bold: "",
      button: "Continue",
    },
    2: {
      title: "Important - Please Read ❗️",
      description:
        "When requested, please approve your Camera and Microphone permissions. This guarantees that you can see and communicate with everyone on Pastime.",
      bold: "Without enabling these permissions, you will not be able to use Pastime.",
      button: "Continue",
    },
  },
  newVersionDialog: {
    title: "Pastime Updates Available",
    description:
      'Pastime has a new and improved version available - to update immediately, click on the "Refresh" button or "Skip" to update on your next visit.',
    buttonConfirm: "Refresh",
    buttonCancel: "Skip",
  },
};

export const motivationQuotes = [
  "There is nothing on this earth more to be prized than true friendship.",
  "There are no strangers here; Only friends you haven't yet met.",
  "With love and patience, nothing is impossible.",
  "Patience is passion tamed.",
  "Have patience. All things are difficult before they become easy.",
  "He that can have patience can have what he will.",
  "Walking with a friend in the dark is better than walking alone in the light.",
  "Of all possessions a friend is the most precious.",
  "One loyal friend is worth ten thousand relatives.",
  "A single rose can be my garden... a single friend, my world.",
];

export const heShe = (gender = Genders.MALE) => (gender === Genders.MALE ? "he" : "she");

export const himHer = (gender = Genders.MALE) => (gender === Genders.MALE ? "him" : "her");

export const hisHer = (gender = Genders.MALE) => (gender === Genders.MALE ? "his" : "her");
